import { useState } from 'react';
import './RegistrationForm.css';

function RegistrationForm({ campaign, onSubmit, onBack }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Pre-fill from localStorage if available
  const savedCustomer = (() => {
    try {
      return JSON.parse(localStorage.getItem('spe_customer') || '{}');
    } catch { return {}; }
  })();

  const [formData, setFormData] = useState({
    phone_number: savedCustomer.phone_number || '',
    full_name: savedCustomer.full_name || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!formData.phone_number || !formData.full_name) {
      setError('No. telefon dan nama penuh diperlukan');
      return;
    }

    try {
      setLoading(true);
      await onSubmit(formData);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Pendaftaran gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="registration-form animate-fade-in">
      <button onClick={onBack} className="btn-back" type="button">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Kembali
      </button>

      <div className="form-card">
        <h2 className="form-title">{campaign.name}</h2>
        <p className="form-subtitle">Masukkan maklumat anda untuk mendapatkan voucher</p>

        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <label>No. Telefon *</label>
            <input
              type="tel"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
              placeholder="cth. 60123456789"
              required
            />
          </div>

          <div className="form-section">
            <label>Nama Penuh *</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              placeholder="Masukkan nama penuh anda"
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading} className="btn-submit">
            {loading ? 'Mendaftar...' : 'Daftar Sekarang'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default RegistrationForm;
